import MainRoute from "./routes/MainRoute";
import { QueryClient, QueryClientProvider } from "react-query";
import { AuthProvider } from "hooks/queries/useAuth";
import { ReactQueryDevtools } from "react-query/devtools";
import { useHandleImpersonationToken } from "hooks/queries/useWorkerImpersonate";
import { useEffect } from "react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const handleImpersonationToken = useHandleImpersonationToken();

  useEffect(() => {
    handleImpersonationToken();
  }, [handleImpersonationToken]);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <MainRoute />
      </AuthProvider>
      {process.env.NODE_ENV === "development" && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  );
}

export default App;
